import React from 'react'
// import searchWhiteIcon from "../Icon.png";
import IDCard from "../CRM/IDcard/CampaignIDCard";
import CardRender from "../DashboardCardRender";
import WideCard from "../WideCard";
import NavBar from '../NavBar';
import { hrPayrollCardData } from "./HRSideWindow";
import { HRWideCardData } from "../WideCardData"; 

import HRRecruitmentWindow from './HRSideWindow'

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RecruitmentId from './HRComponent/RecruitmentId';
import { useState } from 'react';
export default function HRRecruitment() {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.deptName === 'Marketing'
      } 
      else if (e.target.value === '2') {
        return x.deptName === 'Design'
      }
      else if (e.target.value === '3') {
        return x.deptName === 'Sales'
      }
      else if (e.target.value === '4')  {
        return (x.deptName !== 'Marketing' && x.deptName !== 'Design' && x.deptName !== 'Sales')

      }
    }));
    };

    return (
      <>
        <NavBar />
        <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Human Resource Management </span>
          <span className="color"> &#62; </span>
          <span className="color"> Recruitment </span>
        </p>
      </div>
        <div id="Right-content-Down-First">
          <h2>Recruitment</h2>
          <div style={{ display: "flex", gap: "6px" }}>
          <div className="create-team"
            style={{
              width:'13rem',
              backgroundColor:'#4E6DCB'
            }}
          >
          <span style={{paddingTop:'1px'}}>
          <AddCircleOutlineIcon />
          </span>
           <div >Add Recruitment</div>
          </div>
          <div id="Right-content-Down-Filters">
            {/* <div
              style={{
                "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
                height: "80%",
              }}
            ></div> */}
            <MoreVertIcon />
          </div>
        </div>
        </div>
        <div id="OMS-main-content">
          <div className="hr-order-list-box">
            <div id="click-data">
              <p>All Recruitment</p>
              <p>Hired</p>
              <p>Rejected</p>
            </div>
            <div className="order-list-input-box">
              <div className="order-list-input-left">
              <input
                placeholder="Enter name to search..."
                type="text"
                onChange={(val) => {
                  setCount(
                    IncomingData.filter(
                      (x) =>
                        x.employeeName.match(val.target.value)
                    )
                  );
                  setFiltr1("");
                }}
              />                {/* <img src={searchWhiteIcon} alt="" width="" /> */}
              </div>
              <div className="order-list-input-right">
              <select name="" id="" className="order-list-input-right-filters"
               value={filtr1}
                onChange={handleFilter1}
              >
                <option value="" selected>
                  by department
                </option>
                <option value="1">Marketing</option>
                <option value="2">Design</option>
                <option value="3">Sales</option>
                <option value="4">other</option>
              </select>
              </div>
            </div>
            <table className="th-light" style={{ textAlign: "center" }}>
              <tr>
                <th>Employee Name</th>
                <th>Department Name</th>
                <th>Expected Salary</th>
                <th>Current CTC</th>
                <th>Offer in Hand</th>
                <th>Joining Date</th>
                <th>Total Time</th>
              </tr>
              {count.length > 0
              ? count.map((val) => {
                  return (
                    <tr>
                    <td>{val.employeeName}</td>
                    <td>{val.deptName}</td>
                    <td>{val.expecSalary}</td>
                    <td>{val.currCtc}</td>
                    <td>{val.offerInHand}</td>
                    <td>{val.joinDate}</td>
                    <td>{val.totalTime}</td>
                  </tr>
                  );
                })
              : IncomingData.map((val) => {
                return (
                  <tr>
                    <td>{val.employeeName}</td>
                    <td>{val.deptName}</td>
                    <td>{val.expecSalary}</td>
                    <td>{val.currCtc}</td>
                    <td>{val.offerInHand}</td>
                    <td>{val.joinDate}</td>
                    <td>{val.totalTime}</td>
                  </tr>
                );
              })}
            </table>
          </div>
          {/* <HRRecruitmentWindow cardName={hrRecruitmentCardData}/> */}
          <div>
          
          <div style={{display:'flex',gap:"1rem",width:"30rem"}}>
              <CardRender comp={hrRecruitmentCardData} />
          </div>
            <WideCard data={wideCardData}/>
            <RecruitmentId />
            </div>
        </div>
      </>
    );
  }

  const wideCardData = {
    card1up1: 30,
    card1up3: "increased by 5% since last month",
    card1dnP: "HIRED THIS MONTH",
}

  const hrRecruitmentCardData = [
    {
      card1up1: 20,
      card1up2: "interviews scheduled",
      card1up3: "last increased on 20-01-2022",
      card1dnP: "SCHEDULED",
    },
    {
      card1up1: 10,
      card1up2: "under review",
      card1up3: "increased by 10% since last month",
      card1dnP: "UNDER REVIEW",
    },
  ];
  export const IncomingData=[
    {'employeeName':'Donald','deptName':'Marketing','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'Ron','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Marketing','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Testing','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
    {'employeeName':'John Doe','deptName':'Sales','expecSalary':120000,'currCtc':110000,'offerInHand':120000,'joinDate':'12-08-2022','totalTime':'24 Hours'},
]